<template>
  <div class="pageStyle">
    <div class="content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="item" v-for="(item, index) in dataList" :key="index">
          <div class="title">
            <div class="title-left">
              <div v-if="item.channelDefaultFlag">
                <img
                  src="https://static.xchengtech.cn/6ed91026d39141568861fa2f96911a97.png"
                  alt=""
                />
                <span>当前默认价格码</span>
                <van-icon
                  size="3vw"
                  name="question-o"
                  @click="toTips('price')"
                />
              </div>
              <div v-else>
                <span>{{ parseTime(item.createDateTime) }}</span>
              </div>
            </div>
            <div class="title-right" @click="toEdit(item.code)">
              编辑<van-icon name="arrow" size="3vw" />
            </div>
          </div>

          <div class="table">
            <div class="tableHeader">
              <span>报告名称</span><span>价格（元）</span><span>状态</span>
            </div>
            <div class="row">
              <span>企业经营基础报告</span
              ><span>{{
                item.besoBasePrice
                  ? item.besoBasePrice / 100
                  : item.besoBasePrice
              }}</span
              ><span>{{ item.besoBaseFlag === false ? "下架" : "上架" }}</span>
            </div>
            <div class="row">
              <span>企业涉税风险报告</span
              ><span>{{
                item.besoProPrice ? item.besoProPrice / 100 : item.besoProPrice
              }}</span
              ><span>{{ item.besoProFlag === false ? "下架" : "上架" }}</span>
            </div>
            <div class="row" v-show="item.besoPersonPrice">
              <span>个人信息调查报告</span
              ><span>{{
                item.besoPersonPrice
                  ? item.besoPersonPrice / 100
                  : item.besoPersonPrice
              }}</span
              ><span>{{
                item.besoPersonFlag === false ? "下架" : "上架"
              }}</span>
            </div>
          </div>
          <div
            class="btn"
            :style="
              item.channelDefaultFlag
                ? 'grid-template-columns: repeat(1, 1fr);'
                : 'grid-template-columns: repeat(2, 1fr);'
            "
          >
            <div @click="getPoster(item.code)">
              <span>生成推广海报</span>
            </div>
            <div
              @click="
                setDefaultShow = !setDefaultShow;
                toSetDefaultId = item.code;
              "
              v-show="!item.channelDefaultFlag"
            >
              <span>设为默认</span>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!-- 价格码海报弹窗 -->
    <van-dialog
      class="reportPosterShow"
      v-model="reportPosterShow"
      close-on-click-overlay
      :showConfirmButton="false"
    >
      <img :src="reportPosterImg" />
    </van-dialog>
    <!-- 功能说明: 默认价格码 -->
    <van-dialog
      v-model="tipsShow"
      confirm-button-text="我知道了"
      confirm-button-color="#3e8bf2"
    >
      <div class="tipsShow">
        <div class="title">默认价格码说明</div>
        <div class="item">
          <img
            src="https://static.xchengtech.cn/2f447499528d4fc18a84dd2d723968df.png"
            alt=""
          />
        </div>
        <div class="item">
          设定该价格为默认价格时，<s>首页产品中心</s>-><s>报告授权海报</s>中的价格码将被替换成默认价格码
        </div>
      </div>
    </van-dialog>
    <!-- 设置默认价格码 确认弹窗 -->
    <van-dialog
      v-model="setDefaultShow"
      confirm-button-color="#3e8bf2"
      show-cancel-button
      @confirm="toSetDefault"
    >
      <div class="tipsShow">
        <div class="title">是否确认将当前价格码设为默认?</div>
        <div class="item">
          <img
            src="https://static.xchengtech.cn/2f447499528d4fc18a84dd2d723968df.png"
            alt=""
          />
        </div>
        <div class="item">
          设定该价格为默认价格时，<s>首页产品中心</s>-><s>报告授权海报</s>中的价格码将被替换成默认价格码
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { parseTime, parseDay } from "@/utils/index.js";
import { Icon, Button, List, Dialog, Toast, Notify } from "vant";
import Vue from "vue";
Vue.use(Icon);
Vue.use(List);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Notify);
import {
  getXcCompanyRepoCode,
  genPricePost,
  setDefault,
} from "@/api/companyRep.js";
export default {
  data() {
    return {
      dataList: [],
      reportPosterShow: false,
      reportPosterImg: "",
      setDefaultShow: false,
      loading: false,
      finished: false,
      query: {
        size: 100,
        page: 0,
        sort: "channelDefaultFlag,createDateTime,desc",
      },
      tipsShow: false,
      // 需要设置为默认价格码的id
      toSetDefaultId: "",
    };
  },
  mounted() {},
  created() {},
  computed: {},
  methods: {
    parseTime,
    parseDay,
    toSetDefault() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      setDefault(this.toSetDefaultId)
        .then((res) => {
          Notify({ type: "success", message: "设置成功" });
          this.onSearch();
          Toast.clear();
          console.log("res", res);
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    toEdit(id) {
      this.$router.push({ path: "/companyRepCodeInfo", query: { id: id } });
    },
    onLoad() {
      this.loading = true;
      this.getData();
    },
    onSearch() {
      this.query.page = 0;
      this.finished = false;
      this.loading = true;
      this.dataList = [];
      this.getData();
    },
    getPoster(code) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      // 获取海报
      genPricePost(code)
        .then((ress) => {
          Toast.clear();
          this.reportPosterImg = ress;
          this.reportPosterShow = true;
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    getData() {
      getXcCompanyRepoCode(this.query)
        .then((res) => {
          this.dataList = this.dataList.concat(res.content);
          this.loading = false;
          this.query.page++;
          if (res.content.length == 0) {
            this.finished = true;
          }
        })
        .catch((err) => {
          Toast.clear();
          this.finished = true;
          console.log("err", err);
        });
    },
    toTips() {
      this.tipsShow = !this.ipsShow;
    },
  },
};
</script>

<style scoped>
.pageStyle {
  min-height: 100vh;
  background: url("https://static.xchengtech.cn/a357feeb3f4c4b538daf39780660394e.jpg");
  background-size: 100% auto;
  background-repeat: no-repeat;
  padding: 7vw;
  font-size: 3.6vw;
  background-color: #c0c5ff;
}
/* 价格码卡片 */
.content {
  display: grid;
  gap: 7vw;
  padding-top: 49vw;
}

.content .item {
  background-color: #f8f9fd;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px #84b3ff;
  margin-bottom: 7vw;
}

.content .item .title {
  background-image: linear-gradient(to bottom, #edf5fd, #dde7fd);
  color: #084fc5;
  padding: 3vw 4vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.content .item .title .title-left {
  font-weight: 600;
}
.content .item:nth-of-type(1) .title div:nth-of-type(1) {
  display: flex;
  align-items: center;
  gap: 1vw;
}
.content .item:nth-of-type(1) .title img {
  display: block;
  width: 3.6vw;
}

/* 表格区 */
.content .table {
  display: grid;
  padding: 0 4vw;
}
/* 表格区 表头*/
.content .table .tableHeader {
  display: grid;
  grid-template-columns: auto 25% 25%;
  color: #797a83;
  padding: 4vw 0;
  border-bottom: 1px solid #e9e9e9;
}

/* 表格区 内容 */
.content .table .row {
  display: grid;
  grid-template-columns: auto 25% 25%;
  padding: 4vw 0;
  border-bottom: 1px solid #e9e9e9;
  /* padding-left: 2vw; */
}
.content .table .row span:nth-of-type(1) {
  /* color: #f78a2c; */
  /* font-weight: 600; */
}
/* 表格区 表头区 价格和状态 */
.content .table .tableHeader span:nth-of-type(2),
.content .table .tableHeader span:nth-of-type(3),
.content .table .row span:nth-of-type(2),
.content .table .row span:nth-of-type(3) {
  text-align: center;
}
/* 功能按钮 */
.content .btn {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 4vw;
  gap: 4vw;
  font-size: 3.6vw;
}
.content .btn div {
  display: flex;
  justify-content: center;
  align-items: baseline;
  padding: 3vw 0;
  color: white;
  text-align: center;
  border-radius: 6px;
  gap: 1vw;
  font-weight: 600;
  /* border-radius: 35px; */
}
.content .btn div:nth-of-type(1) {
  color: #4c7dba;
  background-color: #c5def8;
}
.content .btn div:nth-of-type(2) {
  color: #bb7734;
  background-color: #f1dbb9;
}
.content .btn img {
  display: block;
  width: 5vw;
}
.reportPosterShow {
  border-radius: 0;
}
.reportPosterShow img {
  display: block;
  width: 100%;
}
.tipsShow {
  font-size: 3.6vw;
  display: grid;
  padding: 4vw;
}
.tipsShow .title {
  color: #01224d;
  font-weight: 600;
  font-size: 4vw;
  padding-bottom: 3vw;
  text-align: center;
}
.tipsShow .item {
  color: #66717f;
  line-height: 7vw;
}
.tipsShow .item s {
  text-decoration: none;
  color: #ff7c00;
}
.tipsShow .item img {
  padding-bottom: 2vw;
  display: block;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/view/companyRepCode/index.vue